angular.module('picmonicng').factory('FactGroupsResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/fact-groups/:fact_group_id/:resource', {
      fact_group_id: '@fact_group_id',
      resource: '@resource',
    });
  },
]);
